export interface PlaylistItem {
  id: string;
  title: string;
  src: string;
  description?: string;
}

export interface VideoCollection {
  id: string;
  nameKey: string;
  type: 'storylane';
  title?: string;
  playlistItems?: PlaylistItem[];
}

export const videoCollections: VideoCollection[] = [
  {
    id: 'quickStart',
    nameKey: 'quickStart',
    type: 'storylane',
    title: 'quickStart.title',
    playlistItems: [
      {
        id: 'video1',
        title: 'quickStart.video1.title',
        src: 'https://app.storylane.io/demo/u7lv8g7q7msf?embed=inline',
      },
      {
        id: 'video2',
        title: 'quickStart.video2.title',
        src: 'https://app.storylane.io/demo/etsdp5uv6bxu?embed=inline',
      },
      {
        id: 'video3',
        title: 'quickStart.video3.title',
        src: 'https://app.storylane.io/demo/ojwgycvlpmfv?embed=inline',
      },
      {
        id: 'video4',
        title: 'quickStart.video4.title',
        src: 'https://app.storylane.io/demo/okn6djkuvvhh?embed=inline',
      },
      {
        id: 'video5',
        title: 'quickStart.video5.title',
        src: 'https://app.storylane.io/demo/hywv4sguu2oa?embed=inline',
      },
      {
        id: 'video6',
        title: 'quickStart.video6.title',
        src: 'https://app.storylane.io/demo/kerv2dnd4wdb?embed=inline',
      },
      {
        id: 'video7',
        title: 'quickStart.video7.title',
        src: 'https://app.storylane.io/demo/66zxddsfefyt?embed=inline',
      },
      {
        id: 'video8',
        title: 'quickStart.video8.title',
        src: 'https://app.storylane.io/demo/jcqclydgm9m6?embed=inline',
      },
      {
        id: 'video9',
        title: 'quickStart.video9.title',
        src: 'https://app.storylane.io/demo/gfkmhjajtvyi?embed=inline',
      },
      {
        id: 'video10',
        title: 'quickStart.video10.title',
        src: 'https://app.storylane.io/demo/cciyuu3oguay?embed=inline',
      },
      {
        id: 'video11',
        title: 'quickStart.video11.title',
        src: 'https://app.storylane.io/demo/kkgiu0sm70vh?embed=inline',
      },
      {
        id: 'video12',
        title: 'quickStart.video12.title',
        src: 'https://app.storylane.io/demo/g8pphnta2psm?embed=inline',
      },
      {
        id: 'video13',
        title: 'quickStart.video13.title',
        src: 'https://app.storylane.io/demo/zzxkrw8q5t3j?embed=inline',
      },
      {
        id: 'video14',
        title: 'quickStart.video14.title',
        src: 'https://app.storylane.io/demo/0aoxxg3ehdhj?embed=inline',
      },
      {
        id: 'video15',
        title: 'quickStart.video15.title',
        src: 'https://app.storylane.io/demo/b5yizdsynuci?embed=inline',
      },
      {
        id: 'video16',
        title: 'quickStart.video16.title',
        src: 'https://app.storylane.io/demo/m6tdyzhimvgc?embed=inline',
      },
      {
        id: 'video17',
        title: 'quickStart.video17.title',
        src: 'https://app.storylane.io/demo/n7sf8whx6qbs?embed=inline',
      },
      {
        id: 'video18',
        title: 'quickStart.video18.title',
        src: 'https://app.storylane.io/demo/nrzlecpswncp?embed=inline',
      },
      {
        id: 'video19',
        title: 'quickStart.video19.title',
        src: 'https://app.storylane.io/demo/unw7byhuvrkg?embed=inline',
      },
      {
        id: 'video20',
        title: 'quickStart.video20.title',
        src: 'https://app.storylane.io/demo/flijlqz92qgk?embed=inline',
      }
    ]
  }
];